import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AdminServicesService } from '../../admin-services.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-upload-return-tax-admin',
  templateUrl: './upload-return-tax-admin.component.html',
  styleUrls: ['./upload-return-tax-admin.component.css']
})
export class UploadReturnTaxAdminComponent implements OnInit {
  public dropdown: any = [];
  fileToUpload: File = null;
  public selectedType: any;
  fileUploadService: any;
  public website: any;
  // @@@@@@@@@@@@@@
  fileData: File;

  // @@@@@@@@@@@@@

  form = new FormGroup({
    website: new FormControl('', Validators.required),
    chooseFile: new FormControl('', Validators.required)
  });
  fileType: string | Blob;
  adminDetails: any;

  get f() {
    return this.form.controls;
  }

  constructor(public admin: AdminServicesService,
    public toastr: ToastrService,
    public router: Router ,private SpinnerService: NgxSpinnerService) {
  }

  ngOnInit(): void {
   let abc = JSON.parse(localStorage.getItem('userDetails'));
   this.adminDetails = abc;
   this.SpinnerService.show();
    this.admin.uploadDropdown().subscribe((res: any) => {
      this.SpinnerService.hide();
      if (res.code === 200) {
        this.dropdown = res.data;
      }
    });
  }

  fileProgress(files: any) {
   
    let temp_fileData = <File>files.target.files[0];
    console.log(temp_fileData.type);
    if (temp_fileData.type === 'text/html' || temp_fileData.type === 'image/jpeg' || temp_fileData.type === 'image/png' || temp_fileData.type === 'application/json') {
      this.fileData = null;
      // this.toastr.error("not accepeted");
    } else {
      this.fileData = <File>files.target.files[0];
    }

  }

  submit() {
    const formData = new FormData();

    if(this.fileData == null){
      return this.toastr.error("Uploaded file Format is not supported");
    }else {
    formData.append('file', this.fileData);
    formData.append('user_id', this.form.value.website);
    formData.append('type', this.fileData.type);
    formData.append('uploadAdmin',this.adminDetails.userId);
    this.SpinnerService.show();
      this.admin.uploadReturnTax(formData).subscribe((res:any)=>
      {
        this.SpinnerService.hide();
        if(res.code===200)
        {
          this.toastr.success("Upload Succesful");
          setTimeout(() => {
            this.reset();
          }, 500);
        }else {
          this.toastr.error("Upload Failed");
        }
      },(err)=>
      {
        this.SpinnerService.hide();
        this.toastr.error(err,"err while Upload");
      });
    }
  }

  reset()
  {
    this.form.patchValue({website:'',chooseFile:''});
    this.fileData = <File>null;
  }
}